import { QUERY_KEYS } from './queryKeys'
import queryClient from '@/queryClient'

export const invalidateProjects = async () => {
  await queryClient.invalidateQueries({
    queryKey: [QUERY_KEYS.PROJECTS],
  })
}
